import { defineComponent } from "vue";

import "./button.less";

export default defineComponent({
  emits: ["click"],
  props: {
    type: { type: String, default: "default" },
    text: { type: String, default: undefined },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
  },
  setup(props, { slots, emit }) {
    const onClick = (event: MouseEvent) => {
      if (props.disabled || props.loading) return;
      emit("click", event);
    };

    return () => (
      <button
        class={[
          "feiyu-web-button",
          `feiyu-web-button--type-${props.type}`,
          {
            "feiyu-web-button--disabled": props.disabled,
            "feiyu-web-button--loading": props.loading,
          },
        ]}
        type="button"
        onClick={onClick}
      >
        <div class="feiyu-web-button--content">{slots.default?.() ?? props.text}</div>
      </button>
    );
  },
});
